export const enum WellknownZIndex {
    /**
     * This is the z-index that Material UI applies to labels for text fields that are not multiline.
     */
    MUI_BUTTON_LABEL = 1,
    /**
     * The index used in the app for floating buttons that perform actions such as completing a purchase.
     */
    FLOATING_BUTTON = 10,
}

export const enum WellknownHeight {
    /**
     * This is the top bar on most pages. Exceptions include webshop and all the pages under Me.
     */
    PRIMARY_TOP_BAR = 64,
    /**
     * This is the clearance height of the floating buttons such as the checkout button.
     */
    FLOATING_BUTTON_CLEARANCE = 74,
}
